import React from "react";
import { formatDate, isDateFilterInvalid } from "../utils/utils";

export const FilterDate = (props) => {

    const { id, labelValue, filters, setFilters, handleEnter } = props

    function handleInputChange(event) {
        const { name, value } = event.target;
        setFilters({
            ...filters,
            [name]: formatDate(value)
        });
    }

    const value = formatDate(filters[id])
    const isInvalid = isDateFilterInvalid(value)

    return (
        <div className="filter">
            <label htmlFor={id}>{labelValue}:</label>
            <input
                name={id}
                value={value}
                onChange={handleInputChange}
                placeholder="DD/MM/YYYY"
                pattern="\d{2}/\d{2}/\d{4}" required
                onKeyDown={handleEnter}
                style={isInvalid ? { borderColor: "#b82c2c" } : undefined}
            />
        </div>
    );
}

export default FilterDate;